import type {GrpcResponseErrorDetail} from '@aboutyou/data-fetcher';

function getErrorTypes(detail: GrpcResponseErrorDetail) {
  switch (detail.type) {
    case 'bad-request':
      return detail.fieldViolations.map(({field}) => field);
    case 'precondition-failure':
      return detail.violations.map(({type}) => type);
  }

  return [];
}

export function getGrpcFieldViolationsAsFormError<T extends string[]>(
  errorDetails: GrpcResponseErrorDetail[],
  fieldsToCheck: T,
) {
  return (errorDetails || [])
    .map(getErrorTypes)
    .flat()
    .filter(type => fieldsToCheck.includes(type));
}
